export default "__VITE_ASSET__9914428d__"